<script setup>

const props = defineProps({
  isLogin: Boolean,
})

const emit = defineEmits(['toggleSidebar', 'toggleLoginStatus', 'toggleUserInfo'])

const toggleSidebar = () => {
  emit('toggleSidebar');
}

const toggleLoginStatus = () => {
  emit('toggleLoginStatus');
}

const toggleUserInfo = () => {
  emit('toggleUserInfo');
}

</script>

<template>
  <header class="top-bar">
    <div class="top-bar-left">
      <button class="icon-btn" @click="toggleSidebar">☰</button>
      <div class="header-info">
        <span class="status-dot"></span> <span class="status-text">System Ready</span>
      </div>
    </div>
    <div class="top-bar-right">
      <div v-if="!props.isLogin" class="login-trigger" @click="toggleLoginStatus">👤 ログイン</div>
      <div v-else class="user-profile-trigger" @click="toggleUserInfo">
        <div class="avatar-blue">SY</div>
      </div>
    </div>
  </header>

</template>

<style scoped>
.top-bar {
  height: 65px;
  border-bottom: 1px solid #E2E8F0;
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px);
}

.top-bar-left,
.top-bar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #64748B;
  cursor: pointer;
}

.icon-btn:hover {
  color: #0066FF;
}

.status-dot {
  display: none;
}

.status-text {
  font-size: 14px;
  color: #10B981;
  font-weight: 600;
}

.avatar-blue {
  width: 38px;
  height: 38px;
  background: linear-gradient(135deg, #0040FF, #00D1FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

</style>